import { render, staticRenderFns } from "./Xqhz1.vue?vue&type=template&id=61b20939&scoped=true&"
import script from "./Xqhz1.vue?vue&type=script&lang=js&"
export * from "./Xqhz1.vue?vue&type=script&lang=js&"
import style0 from "./Xqhz1.vue?vue&type=style&index=0&id=61b20939&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b20939",
  null
  
)

export default component.exports